import classNames from 'classnames';
import { ReactNode } from 'react';
import { useCenterPanelLayoutContext } from 'features/app_shell/centerPanelLayoutContext';
const centerPanelScrollCss = "c1ysrxmq";
const centerPanelInnerBaseCss = "cuasuys";
const centerPanelInnerDefaultCss = "c1qbxrgt";
const centerPanelInnerWideCss = "chc4tm2";

/**
 * Scrollable center column between top and bottom chrome in `#shell-content`.
 * Scroll lives here, not on `#shell-content`. Layout mode is driven by `useCenterPanelLayout`.
 */
export const CenterPanelContent = ({
  children
}: {
  children: ReactNode;
}) => {
  const {
    layout
  } = useCenterPanelLayoutContext();
  return <div id="shell-content-scroll" className={centerPanelScrollCss} tabIndex={0} role="region" aria-label="Main content">
      <div id="shell-content-inner" className={classNames(centerPanelInnerBaseCss, {
      [centerPanelInnerDefaultCss]: layout === 'default',
      [centerPanelInnerWideCss]: layout === 'wide'
    })}>
        {children}
      </div>
    </div>;
};

require("./CenterPanelContent.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CenterPanelContent.tsx");